import React from 'react';
import {
    Show,
    SimpleShowLayout,
    ArrayField,
    Datagrid,
    TextField,
    BooleanField,
    FunctionField
} from 'react-admin';
import CustomTableList from './CustomTableList';

class QuestionList extends CustomTableList {

    customHandled(fields, fieldName, fieldList) {
        if (fieldName === 'level') {
            fieldList.push(<FunctionField label="Level" render={record => record.level || 'fundamental'} />)
            fieldList.push(<FunctionField label="Level Score" render={record => `${record.level === 'mastery' ? 3 : record.level === 'advanced' ? 2 : 1}`} />)
            return true;
        }
        return false;
    }

    PostShow(props) {
        console.log(props);
        console.log(props.record);
        console.log('-------------------');
        return <Show
            {...props}
            /* disable the app title change when shown */
            title=" " >
            <SimpleShowLayout {...props}>

                <ArrayField source="answers">
                    <Datagrid linkType={false}>
                        <TextField label="Answer" source="answer"/>
                        <BooleanField label="Right Answer" source="rightAnswer"/>
                    </Datagrid>
                </ArrayField>

            </SimpleShowLayout>
        </Show>;
    }
}

export default QuestionList;
